import type {
  AccessGrant,
  AccessResourceType,
} from '~/features/access-control/types/AccessControl';

import { ServiceRequestConfig } from '~/services/createService';
import { clausewitz } from '~/services/serviceInstances';

import type { ResourceAccess } from './accessGrantMapper';
import type { ServerClauseAccessResponse } from './clauseAccessMapper';

import {
  getClauseAccessPath,
  isClauseLibraryAccessResourceType,
  mapClauseAccessRequest,
  mapClauseAccessResponse,
} from './clauseAccessMapper';

type Request = {
  resourceId: string;
  resourceType: AccessResourceType;
  grants: AccessGrant[];
  inheritFromParent: boolean;
};

export const updateClauseResourceAccess = async (
  { grants, inheritFromParent, resourceId, resourceType }: Request,
  options: ServiceRequestConfig = {},
): Promise<ResourceAccess> => {
  if (!isClauseLibraryAccessResourceType(resourceType)) {
    throw new Error(
      `updateClauseResourceAccess does not support resourceType "${resourceType}"`,
    );
  }

  const serverResponse = await clausewitz.put<ServerClauseAccessResponse>(
    getClauseAccessPath(resourceType, resourceId),
    mapClauseAccessRequest({ grants, inheritFromParent, resourceType }),
    options,
  );

  return mapClauseAccessResponse(serverResponse);
};
